import React 
    // { useState } 
    from 'react';

import { 
    TextField
} from '@material-ui/core';

import { useTranslation } from 'react-i18next';
import { handleTextualizeDriverNameAndVehicleType } from '../../../utilities/common';

const DriverLookupInput = (props) => {
    const {classes, userCity, searchList, driverListTemp, 
        transferDriverName, setTransferDriverName,
        transferDriverId, setTransferDriverId
    } = props;
    const {t} = useTranslation('quickTransfer');

    return (
        <>
            <div style={{ marginBottom: 10 }}>
                <span className={classes.titleStyle}>{t('transfer_to_driver')}</span>
                <span style={{ marginLeft: 10 }}>{transferDriverName}</span>
            </div>
            <TextField className={classes.textfieldBatchStyle}
                variant="outlined"
                size="small"
                value={transferDriverId}
                onChange={ (e) => {
                    setTransferDriverName(handleTextualizeDriverNameAndVehicleType(e.target.value, userCity, driverListTemp, searchList));
                    setTransferDriverId(e.target.value);
                }}
            />
        </>
    );
}

export default DriverLookupInput;